module.exports = __webpack_public_path__ + "static/onepager-2b9c5d15268b39d6928f1047bca250bd.pdf";